import {
  FETCH_SETTLEMENT_URL,
  CREATE_SETTLEMENT,
  GET_ROLE,
  GET_PARTY_BASED_ROLE,
  GET_SETTLEMENT_TYPE,
  GET_LIST_OF_ORDER,
  FETCH_UNSETTLED_LIST,
  GET_REPORT,
  GET_LIST_DISCREPANCY,
  RECONCILE_URL,
  LIST_WITH_DISCREPANCY,
  RECONCILE_STATUS_URL,
  OTHER_PARTY_RECONCILE_STATUS_URL,
  RECONCILE_LIST_URL,
  RECONCILE_STATUS_POST_URL,
  EDIT_SETTLEMENT,
  GET_STATUS
} from "src/constants/services";
import axios from "src/utils/axios";

class SettlementService {
  settlementList = (value, customerId) =>
    new Promise((resolve, reject) => {
      axios
        .get(
          `${FETCH_SETTLEMENT_URL}?type=${value.myRole}`
        )
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data?.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });
    unSettledList = (customerId) =>
    new Promise((resolve, reject) => {
      axios
        .get(
          `${FETCH_UNSETTLED_LIST}?customerId=${customerId}`
        )
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data?.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

  getRole = (customerId) =>
    new Promise((resolve, reject) => {
      axios
        .get(`${GET_ROLE}?customerId=${customerId}`)
        .then((response) => {
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

  rolePartyBased = (role, customerId) =>
    new Promise((resolve, reject) => {
      
      axios
        .get(`${GET_PARTY_BASED_ROLE}?role=${role}&customerId=${customerId}`)
        .then((response) => {
          if (response.data) {
            let data = response.data.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

  settlementType = (customerId) =>
    new Promise((resolve, reject) => {
      axios
        .get(`${GET_SETTLEMENT_TYPE}?customerId=${customerId}`)
        .then((response) => {
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

  createSettlement = (orderIdArr, settlementType ,  customerId) =>
    new Promise((resolve, reject) => {
      axios
        .post(CREATE_SETTLEMENT, { orderIdArr, settlementType ,  customerId })
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

    ListOfOrder = (value, selectedCollector, customerId) =>
    new Promise((resolve, reject) => {
      axios
        .get(`${GET_LIST_OF_ORDER}?npId=${value}&role=${selectedCollector}&customerId=${customerId}`)
        .then((response) => {
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });
    getReport = (data, customerId) =>
    new Promise((resolve, reject) => {
      axios
       .post(`${GET_REPORT}?customerId=${customerId}`, data)
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

     OtherPartyListDiscrepancy = () =>
    new Promise((resolve, reject) => {
      axios
       .get(GET_LIST_DISCREPANCY )
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

     discrepancyList = (type, id) =>
    new Promise((resolve, reject) => {
      axios
       .get( `${LIST_WITH_DISCREPANCY}?type=${type}&npId=${id}` )
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

     reconcile = (payload) =>
    new Promise((resolve, reject) => {
      axios
      .post(RECONCILE_URL, payload)
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });
     reconcileStatus = (payload) =>
    new Promise((resolve, reject) => {
      axios
      .post(RECONCILE_STATUS_URL, payload)
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });
    
    otherPartyListReconciliation = () =>
    new Promise((resolve, reject) => {
      axios
      .get(OTHER_PARTY_RECONCILE_STATUS_URL)
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

    reconciliationList = (id) =>
    new Promise((resolve, reject) => {
      axios
      .get( `${RECONCILE_LIST_URL}?npId=${id}` )
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });
    
    reconcileSts = (payload) =>
    new Promise((resolve, reject) => {
      axios
      .post( RECONCILE_STATUS_POST_URL, payload )
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

    editSettlement = (payload) =>
    new Promise((resolve, reject) => {
      axios
      .post( EDIT_SETTLEMENT, payload )
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });
    
    getStatus = () =>
    new Promise((resolve, reject) => {
      axios
      .get(GET_STATUS)
        .then((response) => {
          console.log("GreetingService(fetchGreetings->Response): 1", response);
          if (response.data) {
            let data = response.data;
            console.log("data", data);
            resolve(data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          console.log(
            "GreetingService.fetchGreetings (Response Error):" +
              JSON.stringify(error)
          );
          reject(error);
        });
    });

    
}

const settlementService = new SettlementService();
export default settlementService;
